import { render, staticRenderFns } from "./SchemaInputOrderChangeModal.vue?vue&type=template&id=f2a122ee&scoped=true&"
import script from "./SchemaInputOrderChangeModal.vue?vue&type=script&lang=js&"
export * from "./SchemaInputOrderChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./SchemaInputOrderChangeModal.vue?vue&type=style&index=0&id=f2a122ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a122ee",
  null
  
)

export default component.exports